
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 6 4"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"fill":"#00A551","d":"M0 0h6v4H0z"}}),_c('path',{attrs:{"fill":"#FFD500","d":"M0 0h6v3H0z"}}),_c('path',{attrs:{"fill":"#1A206D","d":"M0 0h6v2H0z"}}),_c('path',{attrs:{"fill":"#EA2839","d":"M0 0h6v1H0z"}})])
          )
        }
      }
    